<div class="usecase-detail" [class.embedded-mode]="embeddedMode">
  <!-- Header and Asset Header - Hidden in embedded mode -->
  <app-header *ngIf="!embeddedMode" [forceLightBackground]="true"></app-header>
  
  <div class="usecase-detail--content">
    <app-asset-header
      *ngIf="!embeddedMode"
      [config]="headerConfig"
      [isLoggedIn]="isLoggedIn"
      [isBookmarked]="isBookmarked"
      [isLiked]="isLiked"
      [showActions]="true"
      (bookmarkClick)="onBookmarkClick()"
      (likeClick)="onLikeClick()"
    ></app-asset-header>
    
    <!-- Main Content: Two Column Layout -->
    <div class="usecase-detail--main-section" *ngIf="!isLoading">
      <div class="usecase-detail--container">
        <!-- Tabs Navigation (Usecase, Discussion only) -->
        <div class="usecase-detail--tabs-wrapper">
          <div class="usecase-detail--tabs">
            <button class="usecase-detail--tab" [class.active]="activeTab === 'usecase'" (click)="setActiveTab('usecase')" type="button">Usecase</button>
            <button class="usecase-detail--tab" [class.active]="activeTab === 'discussion'" (click)="setActiveTab('discussion')" type="button">Discussion</button>
          </div>
          <div class="usecase-detail--tabs-actions" *ngIf="activeTab === 'discussion'">
            <button class="usecase-detail--new-discussion-btn" type="button" (click)="createNewDiscussion()">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              New Discussion
            </button>
          </div>
        </div>

        <div class="usecase-detail--row" [class.full-width]="activeTab !== 'usecase'">
          <!-- Left Column: Sections Content (col-8) -->
          <div class="usecase-detail--col-8" [class.full-width]="activeTab !== 'usecase'">
            <!-- Tab Content: Usecase -->
            <div class="usecase-detail--tab-content" *ngIf="activeTab === 'usecase'">
            <!-- Tags -->
            <div class="usecase-detail--tags-header" *ngIf="usecaseTags.length > 0">
              <span 
                *ngFor="let tag of visibleTags" 
                class="usecase-detail--tag-header"
                [title]="tag"
              >
                {{ tag }}
              </span>
              <span 
                *ngIf="remainingTagsCount > 0"
                class="usecase-detail--more-link-header"
                (click)="openTagsModal()"
              >
                +{{ remainingTagsCount }} More
              </span>
            </div>
            
            <!-- Loop through sections -->
            <div 
              *ngFor="let section of sections" 
              class="usecase-detail--section"
            >
              <!-- Section Title -->
              <h2 class="usecase-detail--section-title" *ngIf="section.title">
                {{ section.title }}
              </h2>
              
              <!-- Section Content (if no subsections) -->
              <p class="usecase-detail--section-content" *ngIf="section.content && !section.subsections">
                {{ section.content }}
              </p>
              
              <!-- Subsections -->
              <div *ngIf="section.subsections && section.subsections.length > 0" class="usecase-detail--subsections">
                <div 
                  *ngFor="let subsection of section.subsections; let i = index" 
                  class="usecase-detail--subsection-item"
                >
                  <!-- Subsection header -->
                  <div class="usecase-detail--subsection-header">
                    <h3 class="usecase-detail--subsection-title">{{ subsection.subtitle }}</h3>
                  </div>
                  
                  <!-- Subsection content (paragraph) -->
                  <p 
                    class="usecase-detail--subsection-content" 
                    *ngIf="subsection.content"
                  >
                    {{ subsection.content }}
                  </p>
                  
                  <!-- Subsection points (bullet list) -->
                  <ul 
                    class="usecase-detail--subsection-points" 
                    *ngIf="subsection.points && subsection.points.length > 0"
                  >
                    <li 
                      *ngFor="let point of subsection.points" 
                      class="usecase-detail--subsection-point"
                    >
                      {{ point }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            </div>

            <!-- Tab Content: Discussion (choice/all API) -->
            <div class="usecase-detail--tab-content usecase-detail--discussion-loading" *ngIf="activeTab === 'discussion' && usecaseDiscussionsLoading">
              <p>Loading discussions...</p>
            </div>
            <div class="usecase-detail--tab-content usecase-detail--discussion-error" *ngIf="activeTab === 'discussion' && !usecaseDiscussionsLoading && usecaseDiscussionsError">
              <p>{{ usecaseDiscussionsError }}</p>
            </div>
            <div class="usecase-detail--tab-content usecase-detail--discussion-list" *ngIf="activeTab === 'discussion' && !usecaseDiscussionsLoading && !usecaseDiscussionsError && usecaseDiscussions.length > 0">
              <div
                *ngFor="let discussion of usecaseDiscussions"
                class="usecase-detail--discussion-item"
                [class.pinned]="discussion.isPinned"
                [class.bookmarked]="discussion.isBookmarked"
                (click)="navigateToDiscussion(discussion.id)"
              >
                <div *ngIf="discussion.isBookmarked" class="discussion-item--bookmark-ribbon" title="Bookmarked">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V19L12 15L5 19V5Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="discussion-item--content">
                  <div class="discussion-item--header">
                    <h4 class="discussion-item--title">{{ discussion.title }}</h4>
                  </div>
                  <p class="discussion-item--description">{{ discussion.description }}</p>
                  <div class="discussion-item--meta">
                    <div class="discussion-item--author">
                      <div class="discussion-item--avatar">{{ discussion.author.charAt(0) }}</div>
                      <span class="discussion-item--author-name">{{ discussion.author }}</span>
                    </div>
                    <div class="discussion-item--stats">
                      <span class="discussion-item--stat">
                        <span *ngIf="discussion.isPinned" class="discussion-item--pinned-icon" title="Pinned">
                          <img src="/pinned.svg" alt="Pinned" class="discussion-item--pinned-icon-img" />
                        </span>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                          <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        {{ discussion.replies }}
                      </span>
                      <span class="discussion-item--stat">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                          <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        {{ discussion.views }}
                      </span>
                      <span class="discussion-item--time">{{ discussion.lastActivity }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="usecase-detail--tab-content usecase-detail--discussion-empty" *ngIf="activeTab === 'discussion' && !usecaseDiscussionsLoading && !usecaseDiscussionsError && usecaseDiscussions.length === 0">
              <p>No discussions yet. Be the first to start a discussion about this usecase.</p>
            </div>
          </div>

          <!-- Right Column: Usecase Details -->
          <div class="usecase-detail--col-right" *ngIf="activeTab === 'usecase'">
            <!-- Activity Overview Card -->
            <div class="usecase-detail--activity-overview">
              <div class="activity-overview--header">
                <h3 class="usecase-detail--section-title">Activity Overview</h3>
              </div>
              <div class="activity-overview--metrics">
                <!-- Like -->
                <div class="activity-overview--metric">
                  <svg class="activity-overview--metric-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span class="activity-overview--metric-value">{{ activityMetrics.likes | number }}</span>
                </div>
                <!-- View -->
                <div class="activity-overview--metric">
                  <svg class="activity-overview--metric-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  <span class="activity-overview--metric-value">{{ activityMetrics.views | number }}</span>
                </div>
              </div>
            </div>

            <div class="usecase-detail--right-section">
              <div class="usecase-detail--right-header">
                <h3 class="usecase-detail--section-title">Usecase details</h3>
              </div>
              
              <!-- Details Section -->
              <div class="usecase-detail--details-section" *ngIf="hasUsecaseDetails || usecaseCardDetails.badge">
                <!-- Permission - from accessPolicy -->
                <div class="usecase-detail--detail-item usecase-detail--permission-item" *ngIf="usecaseCardDetails.badge">
                  <div class="usecase-detail--detail-left">
                    <svg class="usecase-detail--detail-icon-svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div class="usecase-detail--detail-label">Permission:</div>
                  </div>
                  <div class="usecase-detail--detail-right">
                    <span class="usecase-detail--permission-badge">
                      <svg class="usecase-detail--permission-badge-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 2v20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <circle cx="12" cy="12" r="2" fill="currentColor"/>
                      </svg>
                      <span>{{ usecaseCardDetails.badge }}</span>
                    </span>
                  </div>
                </div>
                
                <!-- Organisation -->
                <div class="usecase-detail--detail-item" *ngIf="usecaseDetails.organisation">
                  <div class="usecase-detail--detail-left">
                    <img src="/assets/people (2).svg" alt="Organisation" class="usecase-detail--detail-icon" width="20" height="20" />
                    <div class="usecase-detail--detail-label">Organisation:</div>
                  </div>
                  <div class="usecase-detail--detail-right">
                    <div class="usecase-detail--detail-value">{{ usecaseDetails.organisation }}</div>
                  </div>
                </div>
                
                <!-- Sector -->
                <div class="usecase-detail--detail-item" *ngIf="usecaseDetails.sector">
                  <div class="usecase-detail--detail-left">
                    <img src="/assets/cpu.svg" alt="Sector" class="usecase-detail--detail-icon" width="20" height="20" />
                    <div class="usecase-detail--detail-label">Industry:</div>
                  </div>
                  <div class="usecase-detail--detail-right">
                    <div class="usecase-detail--detail-value">{{ usecaseDetails.sector }}</div>
                  </div>
                </div>
                
                <!-- Org. Type -->
                <div class="usecase-detail--detail-item" *ngIf="usecaseDetails.organizationType">
                  <div class="usecase-detail--detail-left">
                    <img src="/assets/export.svg" alt="Org. Type" class="usecase-detail--detail-icon" width="20" height="20" />
                    <div class="usecase-detail--detail-label">Org. Type:</div>
                  </div>
                  <div class="usecase-detail--detail-right">
                    <div class="usecase-detail--detail-value">{{ usecaseDetails.organizationType }}</div>
                  </div>
                </div>
                
                <!-- Created At -->
                <div class="usecase-detail--detail-item" *ngIf="usecaseCardDetails.createdAt">
                  <div class="usecase-detail--detail-left">
                    <img src="/assets/history.svg" alt="Created At" class="usecase-detail--detail-icon" width="20" height="20" />
                    <div class="usecase-detail--detail-label">Created At:</div>
                  </div>
                  <div class="usecase-detail--detail-right">
                    <div class="usecase-detail--detail-value">
                      {{ getCreatedAtDate(usecaseCardDetails.createdAt) }}
                      <span class="usecase-detail--detail-time" *ngIf="getCreatedAtTime(usecaseCardDetails.createdAt)">
                        {{ getCreatedAtTime(usecaseCardDetails.createdAt) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div class="usecase-detail--loading" *ngIf="isLoading">
      <div class="usecase-detail--container">
        <p>Loading usecase details...</p>
      </div>
    </div>

    <!-- Similar Usecases Section - Hidden in embedded mode -->
    <div class="usecase-detail--similar-section" *ngIf="!isLoading && !embeddedMode">
      <div class="usecase-detail--container">
        <app-similar-datasets 
          [datasets]="similarUsecases"
          [title]="'Related Usecases'"
          [assetType]="'usecase'"
          [itemsToShow]="3"
          [showDots]="true"
          [showArrows]="true"
          [gap]="24"
        ></app-similar-datasets>
      </div>
    </div>
  </div>
  
  <app-footer *ngIf="!embeddedMode"></app-footer>

  <!-- Tags Modal -->
  <app-modal
    [(visible)]="showTagsModal"
    header="All Tags"
    [width]="'600px'"
    [showFooter]="false"
    (visibleChange)="showTagsModal = $event"
  >
    <div class="tags-modal-content">
      <div class="tags-modal--tags">
        <span
          *ngFor="let tag of allTags"
          class="usecase-detail--tag-header"
          [title]="tag"
        >
          {{ tag }}
        </span>
      </div>
    </div>
  </app-modal>

  <!-- Login Modal (only when not embedded) -->
  <app-login-modal *ngIf="!embeddedMode && showLoginModal" (visibleChange)="showLoginModal = false"></app-login-modal>
</div>
